module.exports = __webpack_public_path__ + "img/location-none-storage.e71f224e.svg";